// Tinted icon-tile palettes, keyed by the `accent` field on each step
// definition. Shared by the Welcome overview and the Ready summary.
export const ACCENTS = {
  violet: {
    light: "bg-[#F0EDFD] text-[#7C5CE0]",
    dark: "bg-[#7C5CE0]/15 text-[#B79BFF]",
  },
  indigo: {
    light: "bg-[#EDEFFC] text-[#4F5BD5]",
    dark: "bg-[#4F5BD5]/15 text-[#9AA5F5]",
  },
  blue: {
    light: "bg-[#E9F1FE] text-[#2F64FF]",
    dark: "bg-[#2F64FF]/15 text-[#8FB3FF]",
  },
  rose: {
    light: "bg-[#FDECF2] text-[#E0447F]",
    dark: "bg-[#FB54AE]/15 text-[#FF9CD1]",
  },
};

export const accentClass = (accent, isLight) => {
  const entry = ACCENTS[accent] || ACCENTS.indigo;
  return isLight ? entry.light : entry.dark;
};

export default ACCENTS;
